import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appClick]'
})
export class ClickDirective implements OnInit, OnDestroy {
  @Output() appClick = new EventEmitter<Event>();
  @Input('appClickIgnore') ignoreSelectors: string | string[];

  private removeListener: () => void;

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.removeListener = this.renderer.listen('document', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      if (!target) return;

      // If click is inside host element, ignore
      if (this.el.nativeElement.contains(target)) return;

      // Check ignore selectors
      const ignores = Array.isArray(this.ignoreSelectors) ? this.ignoreSelectors : (this.ignoreSelectors ? [this.ignoreSelectors] : []);
      const anchor = target.closest('a[href], a:not([href=""])');
      for (const sel of ignores) {
        try {
          if (target.closest(sel)) return;
        } catch (e) {
          // ignore invalid selector
        }
      }
      
      this.appClick.emit(event);
    });
  }

  ngOnDestroy(): void {
    if (this.removeListener) this.removeListener();
  }
}
